import { ApiUrl } from "../src/env";
import axios from "axios";
// let ApiUrl = "https://test.fprz.ru";
export default class api {
  static async getNews(search, page) {
    const data = await axios.get(ApiUrl + "/api/new", {
      params: {
        search: search,
        page: page,
      },
    });

    return data;
  }

  static async getNew(id) {
    const data = await axios.get(`${ApiUrl}/api/new/${id}`, {
      params: {},
    });
    return data;
  }

  static async getNewDoc() {
    const data = await axios.get(ApiUrl + "/api/newdoc", {});

    return data;
  }

  static async getAnti(search) {
    const data = await axios.get(ApiUrl + "/api/anti", {
      params: {
        search: search,
      },
    });

    return data;
  }

  static async getAlboms(search) {
    const data = await axios.get(ApiUrl + "/api/alboms", {
      params: {
        search: search,
      },
    });

    return data;
  }

  static async getContacts(search) {
    const data = await axios.get(ApiUrl + "/users/getusers", {
      params: {
        search: search,
      },
    });

    return data;
  }

  static async getDocs(search) {
    const data = await axios.get(ApiUrl + "/api/docs", {
      params: {
        search: search,
      },
    });

    return data;
  }

  static async getPolog(search) {
    const data = await axios.get(ApiUrl + "/api/polog", {
      params: {
        search: search,
      },
    });

    return data;
  }

  static async getProtocol(search) {
    const data = await axios.get(ApiUrl + "/api/protocol", {
      params: {
        search: search,
      },
    });

    return data;
  }

  static async getRecord(search) {
    const data = await axios.get(ApiUrl + "/api/record", {
      params: {
        search: search,
      },
    });

    return data;
  }

  static async getNorm(search) {
    const data = await axios.get(ApiUrl + "/api/norm", {
      params: {
        search: search,
      },
    });

    return data;
  }

  static async getCal() {
    const data = await axios.get(ApiUrl + "/api/calendar", {});

    return data;
  }

  static async loginUser(username, password) {
    console.log(username, password);
    const data = await axios.post(ApiUrl + "/users/login", {
      username: username,
      password: password,
    });
    console.log(data);
    return data; //при валидном логине и пароле получаем промис(результат+токен)
  }

  static async registerUser(username, password, first_name, last_name, email) {
    const data = await axios.post(ApiUrl + "/users/registeruser", {
      username: username,
      password: password,
      first_name: first_name,
      last_name: last_name,
    });

    return data; //при валидном логине и пароле получаем промис(результат+токен)
  }

  static async postZayavka(
    first_name,
    last_name,
    email,
    third_name,
    phone,
    date_birth,
    razrad,
    ves_kat,
    best_sum,
    sorev_name,
    coach_name,
  ) {
    const data = await axios.post(ApiUrl + "/users/zayavka", {
      first_name: first_name,
      last_name: last_name,
      email: email,
      third_name: third_name,
      phone: phone,
      date_birth: date_birth,
      razrad: razrad,
      ves_kat: ves_kat,
      best_sum: best_sum,
      sorev_name: sorev_name,
      coach_name: coach_name,
    });

    return data;
  }

  static async postMail(first_name, email, body_mes, send_email) {
    const data = await axios.post(ApiUrl + "/users/email_mes", {
      first_name: first_name,
      email: email,
      body_mes: body_mes,
      send_email: send_email,
    });

    return data;
  }

  static async authCheck(token) {
    const data = await axios.post(
      ApiUrl + "/users/auth",
      {},
      {
        headers: {
          AUTHORIZATION: token,
          auth: token,
        },
      },
    );
    return data;
  }

  static async getDateUser(token) {
    const data = await axios.get(ApiUrl + "/users/getuser", {
      headers: {
        AUTHORIZATION: token,
        auth: token,
      },
    });

    return data;
  }

  static async sendLike(countLike, id) {
    const data = await axios.patch(`${ApiUrl}/api/like/${id}`, {
      countLike: countLike,
    });
    return data;
  }

  static async sendLikeComent(countLike, id) {
    const data = await axios.patch(`${ApiUrl}/api/likeComent/${id}`, {
      countLike: countLike,
    });
    return data;
  }

  // static async sendComent(coment, id) {
  //   const data = await axios.post(`${ApiUrl}/api/coment/${id}`, {
  //     coment: coment,
  //   });
  //   return data;
  // }

  static async sendView(id) {
    const data = await axios.patch(`${ApiUrl}/api/view/${id}`, {});
    return data;
  }

  static async loadAvatar(token, file) {
    const formData = new FormData();
    formData.append("imageFile", file);
    const data = await axios.post(ApiUrl + "/users/loadAvatar", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
        AUTHORIZATION: token,
        auth: token,
        "Content-Disposition": "attachment; filename=file",
        filename: "file",
      },
    });
    return data;
  }

  static async PostSportsmen(token, formData) {
    console.log("оптправляем токен");
    console.log(token);
    const data = await axios.patch(ApiUrl + "/users/loadlk", formData, {
      // onUploadProgress: (progressEvent) => {
      //   const progress = Math.round(
      //     (progressEvent.loaded * 100) / progressEvent.total,
      //   );
      //   console.log(`Upload Progress: ${progress}%`);
      // },
      headers: {
        "Content-Type": "multipart/form-data",
        AUTHORIZATION: token,
        auth: token,
      },
    });
    console.log("оптправляем токен111");
    console.log(token);
    return data;
  }

  static async delComent(id, token, csrfToken) {
    const data = await axios.patch(`${ApiUrl}/api/coment/${id}`, {
      // headers: {
      //   AUTHORIZATION: token,
      //   auth: token,
      //   "X-CSRFToken": csrfToken,
      // },
    });

    return data;
  }

  static async changeLike_Coment(countLike, id) {
    const data = await axios.patch(`${ApiUrl}/api/like/${id}`, {
      countLike: countLike,
    });
    return data;
  }

  // static async getIsHuman(token) {
  //   const data = await axios.post(
  //     "https://www.google.com/recaptcha/api/siteverify",
  //     {},
  //     {
  //       headers: {
  //         Accept: "application/json",
  //         "Content-Type": "application/x-www-form-urlencoded; charset=utf-8",
  //       },
  //         body: `secret=${RECAPTCHA_SERVER_KEY}&response=${humanKey}`,
  //      }

  //   );
  //   return data;
  // }
}
